import type { CheckboxProps } from '@mui/material/Checkbox';
import MuiCheckbox from '@mui/material/Checkbox';
import { forwardRef } from 'react';

const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>((props, ref) => {
  return <MuiCheckbox ref={ref} {...props} />;
});

Checkbox.displayName = 'Checkbox';
export default Checkbox;
